import { render } from "./PrinterSetting.vue?vue&type=template&id=ed5796b2"
import script from "./PrinterSetting.vue?vue&type=script&lang=js"
export * from "./PrinterSetting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__